/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmployeeState {
    AVAILABLE_FOR_TRANSFER = 'AVAILABLE_FOR_TRANSFER',
    ACTIVE_IN_PRESENT_OFFICE = 'ACTIVE_IN_PRESENT_OFFICE',
    TRANSFERRED_TO_ANOTHER_DISTRICT = 'TRANSFERRED_TO_ANOTHER_DISTRICT',
    LOCKED = 'LOCKED',
    DELETED = 'DELETED',
}